import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Toaster } from 'react-hot-toast';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Project from './pages/Project';
import Team from './pages/team/Team';
import TeamMemberPage from './pages/team/TeamMember';
import PodcastEpisode from './pages/Podcasts/PodcastEpisode';
import { Podcasts } from './pages/Podcasts';
import LatestEpisodes from './pages/LatestEpisodes';
import News from './pages/news/News';
import NewsArchive from './pages/news/NewsArchive';
import Courses from './pages/courses/Courses';
import ScientificCourses from './pages/courses/ScientificCourses';
import Contact from './pages/Contact';
import CMS from './pages/CMS';
import SignIn from './pages/auth/SignIn';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/shared/ProtectedRoute';
import ScrollRestoration from './components/shared/ScrollRestoration';
import PodcastDetails from './pages/Podcasts/PodcastDetails';
import NewsArticle from './pages/news/NewsArticle';

// Admin Pages
import Notifications from './pages/admin/Notifications';
import Settings from './pages/admin/Settings';
import Permissions from './pages/admin/Permissions';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-background text-foreground flex flex-col">
        <Toaster position="top-right" />
        <ScrollRestoration />
        <Navbar />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="flex-grow"
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project" element={<Project />} />
            <Route path="/podcasts/all" element={<Podcasts />} />
            <Route path="/team" element={<Team />} />
            <Route path="/team/:id" element={<TeamMemberPage />} />
            <Route path="/podcasts" element={<Podcasts />} />
            <Route path="/podcasts/latest" element={<LatestEpisodes />} />
            <Route path="/podcasts/:id" element={<PodcastEpisode />} />
            <Route path="/podcasts/:category" element={<Podcasts />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/archive" element={<NewsArchive />} />
            <Route path="/news/:slug" element={<NewsArticle />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/admin/settings" element={<Settings />} />
            <Route path="/agrupamento/secundario/cientifico" element={<ScientificCourses />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/signin" element={<SignIn />} />
            
            {/* Protected Admin Routes */}
            <Route
              path="/cms"
              element={
                <ProtectedRoute>
                  <CMS />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/notifications"
              element={
                <ProtectedRoute>
                  <Notifications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/permissions"
              element={
                <ProtectedRoute>
                  <Permissions />
                </ProtectedRoute>
              }
            />
            
            <Route path="*" element={<NotFound />} />
          </Routes>
        </motion.div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;